<template>
  <div>
    <NavBarSearch />
    <div class="row pt-5 mx-0">
      <div class="col-lg-12 col-md-12 b-grey">
        <div class="row mx-3 py-4" style="height:auto;">
          <div class="col-lg-3 col-md-4 col-6 my-2 bl-grey px-0">
            <div class="col-lg-4 col-md-4 col-6 d-inline-block align-middle">
              <div
                style="width:70px; height:70px; background:red;"
                class="rounded-circle d-inline-block"
              ></div>
            </div>
            <div class="col-lg-8 col-md-6 col-6 d-inline-block align-middle">
              <p class="mb-0 fs-18">Cindy Yuvia</p>
              <span class="fs-14 t-grey"><i>Verified Account</i></span>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-6 my-2 text-center bl-grey">
            <div class="col-lg-12">
              <h1 class="mb-0">5</h1>
              <p class="fs-12 mb-0 font-weight-bold">PreOrder Histori</p>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-6 my-2 text-center bl-grey">
            <div class="col-lg-12">
              <h1 class="mb-0">2</h1>
              <p class="fs-12 mb-0 font-weight-bold">PreOrder Item</p>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-6 my-2 text-center bl-grey">
            <p class="fs-12">Jumlah yang harus di bayar</p>
            <span class="fs-12 align-top">IDR</span
            ><span class="fs-24">150 Juta</span>
            <p class="fs-12 font-weight-bold mb-0">
              Setor dalam waktu <span class="t-red">0</span> hari
            </p>
          </div>
          <div class="col-lg-3 col-md-2 col-6 my-2">
            <p class="fs-12">Saldo PreDownpayment</p>
            <p class="mb-0">
              <span class="fs-12 align-top">IDR</span>
              <span class="fs-24 mb-0">3 Juta</span>
            </p>
            <div
              class="btn-type col-md-12 col-sm-12 fs-11 py-1 w-50 px-1 text-center d-inline-block align-middle mb-0 b-new-grey mr-2 t-grey"
            >
              History pembayaran
            </div>
            <div
              class="btn-type col-md-12 col-sm-12  fs-11 py-1 w-25 px-1 text-center d-inline-block align-middle mb-0 b-new-grey t-grey"
            >
              Tarik
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 bg-white px-0">
        <div class="row mx-0">
          <div class="col-lg-5 px-0">
            <img class="w-100" src="@/assets/img/car_2.png" alt="" />
          </div>
          <div class="col-lg-3 col-md-4 col-sm-4 col-xm-6  py-3 m-auto">
            <div class="col-12 bl-grey">
              <p class="fs-20 font-weight-bold mb-0">2019 ACURA ILX</p>
              <p class="fs-14 mb-0"><i>Sudah tersedia seharga</i></p>
              <p class="mb-0 font-weight-bold">
                <span class="fs-12 align-top mr-1">IDR</span>
                <span class="fs-24 mb-0">190 Juta</span>
              </p>
              <span class="t-s-grey align-middle mr-3"><i>Warna</i></span>
              <div
                style="width:50px; height:50px;"
                class="b-red rounded-circle d-inline-block align-middle"
              ></div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-4 col-xm-6 py-5 bl-grey m-auto">
            <div class="col-lg-12">
              <p class="fs-14 mb-0" style="color:grey;">
                <i>Sudah dibayarkan</i>
              </p>
              <p class="mb-0 font-weight-bold">
                <span class="fs-12 align-top mr-1">IDR</span>
                <span class="fs-24 mb-0">50 Juta</span>
              </p>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-4 col-xm-6 py-5 bl-grey m-auto">
            <div class="col-lg-12">
              <p class="fs-14 mb-0" style="color:grey;">
                <i>Sisa pembayaran</i>
              </p>
              <p class="mb-0 font-weight-bold">
                <span class="fs-12 align-top mr-1">IDR</span>
                <span class="fs-24 mb-0">50 Juta</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 b-grey pt-3 pb-2">
        <div class="row bg-white">
          <div class="col-lg-3 px-0">
            <img class="w-100 h-100" src="@/assets/img/red_2.png" alt="" />
          </div>
          <div class="col-lg-3 px-0">
            <img class="w-100 h-100" src="@/assets/img/red_3.png" alt="" />
          </div>
          <div class="col-lg-6 px-0">
            <img class="w-100" src="@/assets/img/red_4.png" alt="" />
          </div>
        </div>
      </div>
      <div class="col-lg-12 bg-white px-5">
        <div class="row px-5 py-5" id="relax">
          <div class="col-12 mb-3">
            <p class="font-weight-bold mb-0">Preorder Bill</p>
            <p class="fs-28 font-weight-bold">Rp 30.000.000</p>
          </div>
          <div class="col-lg-4 bl-grey mt-3">
            <p class="fs-14 font-weight-bold">Cara pembayaran</p>
            <b-form-radio
              v-model="selected"
              name="some-radios"
              value="transfer"
              class="mb-3 pointer my_control"
              >Transfer dari bank lain ke BCA</b-form-radio
            >
            <b-form-radio
              v-model="selected"
              name="some-radios"
              value="bca_va"
              class="mb-3 pointer"
              >BCA Virtual Account</b-form-radio
            >
            <b-form-radio
              v-model="selected"
              name="some-radios"
              value="kk"
              class="mb-3 pointer"
              >Kartu kredit</b-form-radio
            >
            <b-form-radio
              v-model="selected"
              name="some-radios"
              value="lain"
              class="mb-3 pointer"
              >Lain nya</b-form-radio
            >
            <input
              type="text"
              placeholder="Sebutkan"
              class="input_grey_up py-2 px-3"
            />
          </div>
          <div class="col-lg-4 bl-grey mt-3">
            <p class="fs-14 font-weight-bold px-3">Pembayaran Kartu Kredit</p>
            <div class="col-lg-12 my-3 px-0">
              <input
                type="text"
                placeholder="Nama Pemilik rekening"
                class="input_grey_up py-2 px-3 w-100"
              />
            </div>
            <div class="col-lg-12 px-0">
              <div class="row">
                <div class="col-lg-8 my-3 position-relative">
                  <input
                    placeholder="Nomor kartu kredit"
                    class="input_grey_up py-2 px-3 w-100"
                    v-model="credit_card"
                    @keyup="check_credit($event)"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    type="number"
                    maxlength="16"
                  />
                  <span class="fs-10 position-absolute err_mess">{{
                    error_mes_cc
                  }}</span>
                </div>
                <div class="col-lg-4 my-3">
                  <input
                    placeholder="CVV"
                    v-model="cvv"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    type="number"
                    maxlength="3"
                    class="input_grey_up py-2 px-3 w-100"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-12 my-3 px-0">
              <textarea
                name=""
                id=""
                cols="30"
                rows="3"
                class="input_grey_up py-2 px-3 w-100"
                placeholder="Alamat"
              ></textarea>
            </div>
          </div>
          <div class="col-lg-4 text-center align-self-end">
            <div class="btn-type w-75 green_btn text-white font-weight-bold">
              Lunasi Transaksi
            </div>
            <div class="btn-type w-75 font-weight-bold">Kembali</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBarSearch from "@/components/partials/NavBarSearch.vue";
export default {
  data() {
    return {
      cvv: null,
      credit_card: null,
      selected: "transfer"
    };
  },
  methods: {
    check_credit(e) {
      if (e.target.value.length < 16) {
        this.error_mes_cc = "Nomor kartu kredit harus 16 digit";
      } else {
        this.error_mes_cc = "";
      }
    }
  },
  components: { NavBarSearch }
};
</script>
<style>
.custom-control-input:checked ~ .custom-control-label::before {
  color: #90c750 !important;
  border-color: #90c750 !important;
  background-color: #90c750 !important;
}
.input_grey_up {
  background: #f6f6f6;
  border: none;
  border-radius: 10px;
  color: #707070;
  font-size: 14px;
}
.input_grey_up:focus {
  border: none;
  outline: none;
}
.green_btn {
  background: #90c750 !important;
}
.err_mess {
  bottom: -17px;
  left: 18px;
  color: red;
}
</style>
